/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import homeStore from '../store/homeStore';
const StoreMap: React.FC = () => {
  const stores = homeStore.storeLocations;
  const [map, setMap] = useState<any | null>(null);
  const [ymapsLoaded, setYmapsLoaded] = useState(false);

  // Load stores data (in a real app, this would be an API call)
//   useEffect(() => {
//     // This would typically be an API call, but we'll use the provided data
//     const mockStores: Store[] = [
//       // ... paste all the store data from your question here ...
//     ];
//     setStores(mockStores);
//   }, []);

  // Load Yandex Maps API
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://api-maps.yandex.ru/2.1/?apikey=c4338551-9b2b-4fd5-a552-9f6e85ae674b&suggest_apikey=3fdf44f3-77ff-4047-b5ef-4495c4bab4fe&lang=ru_RU';
    script.async = true;
    script.onload = () => {
      // @ts-ignore
      window.ymaps.ready(() => setYmapsLoaded(true));
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Initialize map when Yandex Maps is loaded and stores are available
  useEffect(() => {
    if (!ymapsLoaded) return;

    // @ts-ignore
    const ymaps = window.ymaps;

    // Create map instance
    const newMap = new ymaps.Map('map', {
      center: [55.751574, 37.573856], // Center on Moscow by default
      zoom: 5,
      controls: ['zoomControl', 'fullscreenControl']
    });

    // Add stores to the map
    homeStore.storeLocations.forEach(store => {
      // Skip stores without coordinates (or use city geocoding)
      if (!store.coordinates) return;

      const placemark = new ymaps.Placemark(
        store.coordinates,
        {
          balloonContent: `
            <div style="padding: 10px;">
              <h3 style="margin: 0 0 10px 0;">${store.city}</h3>
              <p style="margin: 0 0 5px 0;">${store.address}</p>
              <div style="margin-top: 5px;">
                <strong>Телефоны:</strong>
                <ul style="margin: 5px 0 0 0; padding-left: 20px;">
                  ${store.phones.map(phone => `<li>${phone}</li>`).join('')}
                </ul>
              </div>
            </div>
          `
        },
        {
          iconLayout: 'default#image',
          iconImageHref: "/map-location-dot1.png",
          iconImageSize: [35, 35],
          iconImageOffset: [-15, -44]
        }
      );

      newMap.geoObjects.add(placemark);
    });

    // Fit map to show all placemarks
    if (stores.some(store => store.coordinates)) {
      newMap.setBounds(newMap.geoObjects.getBounds(), {
        checkZoomRange: true
      });
    }

    setMap(newMap);

    return () => {
      if (newMap) {
        newMap.destroy();
      }
    };
  }, [ymapsLoaded, stores]);

  // Function to handle city selection (if you want to add a city filter)
  const handleCityChange = (city: string) => {
    if (!map || !ymapsLoaded) return;

    // @ts-ignore
    const ymaps = window.ymaps;

    const cityStores = stores.filter(store => store.city === city);
    if (cityStores.length === 0) return;

    // If we had coordinates, we would center on them
    // For now, we'll just geocode the city name
    ymaps.geocode(city, {
      results: 1
    }).then((res: any) => {
      const firstGeoObject = res.geoObjects.get(0);
      const coords = firstGeoObject.geometry.getCoordinates();
      map.setCenter(coords, 12);
    });
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div style={{ marginBottom: '20px' }}>
        <h2 className='text-2xl font-bold text-center'>Наши магазины</h2>
        <div className='text-2xl font-bold text-center'>
          <label htmlFor="city-select">Выберите город: </label>
          <select 
            id="city-select" 
            onChange={(e) => handleCityChange(e.target.value)}
            style={{ padding: '5px', marginRight: '10px',
              appearance: 'none', // Отключает стандартные стили
              WebkitAppearance: 'none', // Для Safari
              MozAppearance: 'none', // Для Firefox
              border: '1px solid #ccc', // Явно задаем границу
              borderRadius: '4px', //
              cursor: "pointer",
             }}
          >
            <option value="">Все города</option>
            {Array.from(new Set(stores.map(store => store.city))).map(city => (
              <option key={city} value={city}>{city}</option>
            ))}
          </select>
        </div>
      </div>
      
      <div 
        id="map" 
        style={{ 
          width: '100%', 
          height: '600px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }} 
      />
      
      {/* <div style={{ marginTop: '20px' }}>
        <h3>Список магазинов</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
          {stores.map(store => (
            <div 
              key={store.id} 
              style={{
                padding: '15px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                backgroundColor: '#f9f9f9'
              }}
            >
              <h4 style={{ marginTop: 0 }}>{store.city}</h4>
              <p>{store.address}</p>
              <div>
                <strong>Телефоны:</strong>
                <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px' }}>
                  {store.phones.map((phone, index) => (
                    <li key={index}>
                      <a href={`tel:${phone.replace(/[^0-9+]/g, '')}`}>{phone}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default observer(StoreMap);